import { siteConfig } from '@/mocks/siteConfig';

export default function BrandIntro() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            品牌介绍
          </h2>
          <p className="text-sm text-secondary-500">关于福利视频导的故事与使命</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          <div className="rounded-lg overflow-hidden aspect-[4/3]">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20creative%20office%20workspace%20with%20warm%20ambient%20lighting%20team%20collaborating%20around%20large%20screen%20displaying%20video%20content%20clean%20minimalist%20design%20with%20plants%20and%20warm%20wooden%20accents%20professional%20yet%20cozy%20atmosphere&width=800&height=600&seq=about-brand&orientation=landscape"
              alt="福利视频导团队办公环境"
              title="福利视频导团队"
              className="w-full h-full object-cover"
            />
          </div>
          <div>
            <p className="text-sm text-secondary-700 leading-relaxed mb-4">
              {siteConfig.brandIntro}
            </p>
            <div className="grid grid-cols-2 gap-4 mt-6">
              <div className="bg-background-100 rounded-lg p-4 text-center">
                <p className="text-xl font-heading text-primary-500">{siteConfig.stats.totalVideos}</p>
                <p className="text-xs text-secondary-500 mt-1">视频资源</p>
              </div>
              <div className="bg-background-100 rounded-lg p-4 text-center">
                <p className="text-xl font-heading text-accent-500">{siteConfig.stats.dailyVisitors}</p>
                <p className="text-xs text-secondary-500 mt-1">日均访问</p>
              </div>
              <div className="bg-background-100 rounded-lg p-4 text-center">
                <p className="text-xl font-heading text-accent-500">{siteConfig.stats.categories}个</p>
                <p className="text-xs text-secondary-500 mt-1">内容分类</p>
              </div>
              <div className="bg-background-100 rounded-lg p-4 text-center">
                <p className="text-xl font-heading text-primary-500">{siteConfig.stats.articlesPublished}</p>
                <p className="text-xs text-secondary-500 mt-1">精选文章</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}